import {DashboardAdaptiveDensityBoard} from '../types/DashboardAdaptiveDensityBoard';
import {DashboardAdaptiveDensityCoordinator} from './DashboardAdaptiveDensityCoordinator';

export const createDashboardAdaptiveDensityBoard = (): DashboardAdaptiveDensityBoard => {
  const coordinator = new DashboardAdaptiveDensityCoordinator();

  return {
    contextValue: {
      register: (participant) => coordinator.register(participant),
      update: (participant) => coordinator.update(participant),
      getIsDragging: coordinator.getIsDragging,
      subscribeDragging: coordinator.subscribeDragging,
    },
    setRoot: (root) => coordinator.setRoot(root),
    setLayoutSignature: (signature) => coordinator.setLayoutSignature(signature),
    setDragging: (isDragging) => coordinator.setDragging(isDragging),
  };
};
